import { ClipboardService } from './clipboard.service';

export default angular
  .module('sfMobile.services.clipboard', [])
  .service('clipboardService', ClipboardService).name;
